// assets/tmf-dialog.js - TMF · open a native <dialog> from any button with data-tmf-open="<dialog id>".
// Used by the size guide link on the product page (blocks/tmf-size-table.liquid). Close: [data-tmf-close],
// Esc (native), or a click on the backdrop. One delegated listener, no framework.
document.addEventListener('click', (event) => {
  const target = /** @type {Element | null} */ (event.target instanceof Element ? event.target : null);
  if (!target) return;
  const opener = target.closest('[data-tmf-open]');
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('data-tmf-open') || '');
    if (dialog instanceof HTMLDialogElement) {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
    }
    return;
  }
  const closer = target.closest('[data-tmf-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }
  if (target instanceof HTMLDialogElement && target.classList.contains('tmf-dialog')) {
    // click on the backdrop (the dialog box itself is the event target only outside its content)
    const r = target.getBoundingClientRect();
    const e = /** @type {MouseEvent} */ (event);
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) target.close();
  }
});
